import { Controller } from "@hotwired/stimulus"
import { DataTable } from 'simple-datatables'

// Connects to data-controller="datatable"
export default class extends Controller {
	static targets = ["table", "wrapper"]
	static values = {
		searchBar: { type: Boolean, default: true },
		perPageSelect: { type: Boolean, default: true },
		hideTableTop: Boolean,
		hideTableBottom: Boolean,
		noSort: Array
	}

	initialize() {
		this.tableId = Math.random().toString(36)
		this.element.setAttribute("id", this.tableId)
	}

	connect() {
		if (this.hasTableTarget) {
			let dataTable = new DataTable(this.tableTarget, {
				searchable: this.searchBarValue,
				perPageSelect: this.perPageSelectTag(),
				labels: {
					placeholder: "検索...",
					searchTitle: "テーブル内検索",
					pageTitle: "ページ {page}",
					noRows: "エントリーがありません",
					info: "{rows}件中 {start}～{end}件を表示しています",
					noResults: "検索結果が見つかりませんでした",
				},
				columns: [
					// Disable sorting on the first column
					{ select: this.noSortValue, sortable: false },
				],
			});

			let parentElement = document.getElementById(this.tableId)
			let preloadWrapper = this.wrapperTarget
			let searchBar = this.searchBarValue
			let perPageSelect = this.perPageSelectValue
			let hideTableTop = this.hideTableTopValue
			let hideTableBottom = this.hideTableBottomValue

			// Add Bootstrap styles to the elements in the header
			dataTable.on("datatable.init", function () {
				// Fade in after init
				preloadWrapper.classList.add("opacity-10");
				if (hideTableTop) {
					let dataTableTop = parentElement.querySelector(".dataTable-top");
					dataTableTop.classList.add("hidden-div")
				}
				if (hideTableBottom) {
					let dataTableBottom = parentElement.querySelector(".dataTable-bottom");
					dataTableBottom.classList.add("hidden-div")
				}
				if (searchBar) {
					let input = parentElement.querySelector(".dataTable-input");
					input.classList.add("form-control", "form-control-lg");
				}
				if (perPageSelect) {
					let dataTableSelect = parentElement.querySelector(".dataTable-selector");
					dataTableSelect.classList.add("form-control");
					const nextNode = dataTableSelect.nextSibling;
					nextNode.textContent = " 表示件数";
				}
				let dataTableContainer = parentElement.querySelector(".dataTable-container");
				dataTableContainer.classList.add("border-0");
			});
		}
	}

	perPageSelectTag() {
		if (this.perPageSelectValue) {
			return [5, 10, 15, 20, 25]
		} else {
			return false
		}
	}
}